export const RESIDENTIAL_AND_COMMERCIAL_DEV_LEVEL_1_THREAT_ID = 1
export const AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID = 2
export const ENERGY_PRODUCTION_AND_MINING_LEVEL_1_THREAT_ID = 3
export const TRANSPORTATION_AND_SERVICE_CORRIDORS_LEVEL_1_THREAT_ID = 4
export const BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID = 5
export const HUMAN_INTRUSIONS_AND_DISTURBANCE_LEVEL_1_THREAT_ID = 6
export const NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID = 7
export const INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID = 8
export const POLLUTION_LEVEL_1_THREAT_ID = 9
export const GEOLOGICAL_EVENTS_LEVEL_1_THREAT_ID = 10
export const CLIMATE_CHANGE_AND_SEVERE_WEATHER_LEVEL_1_THREAT_ID = 11
export const OTHER_OPTIONS_LEVEL_1_THREAT_ID = 12

export const level1Threats = [
  { id: RESIDENTIAL_AND_COMMERCIAL_DEV_LEVEL_1_THREAT_ID, name: 'Residential & commercial development' },
  { id: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID, name: 'Agriculture & aquaculture' },
  { id: ENERGY_PRODUCTION_AND_MINING_LEVEL_1_THREAT_ID, name: 'Energy production & mining' },
  { id: TRANSPORTATION_AND_SERVICE_CORRIDORS_LEVEL_1_THREAT_ID, name: 'Transportation & service corridors' },
  { id: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID, name: 'Biological resource use' },
  { id: HUMAN_INTRUSIONS_AND_DISTURBANCE_LEVEL_1_THREAT_ID, name: 'Human intrusions & disturbance' },
  { id: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID, name: 'Natural system modifications' },
  {
    id: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    name: 'Invasive & other problematic species, genes & diseases'
  },
  { id: POLLUTION_LEVEL_1_THREAT_ID, name: 'Pollution' },
  { id: GEOLOGICAL_EVENTS_LEVEL_1_THREAT_ID, name: 'Geological events' },
  { id: CLIMATE_CHANGE_AND_SEVERE_WEATHER_LEVEL_1_THREAT_ID, name: 'Climate change & severe weather' },
  { id: OTHER_OPTIONS_LEVEL_1_THREAT_ID, name: 'Other options' }
]
